var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            width: "40%",
            "modal-append-to-body": false,
            "append-to-body": "",
          },
          on: { close: _vm.handleClose },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "baseForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "生成方式", prop: "generateType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.generateType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "generateType", $$v)
                        },
                        expression: "form.generateType",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            disabled: _vm.optionType !== "add",
                            label: 1,
                          },
                        },
                        [_vm._v("立即生成")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            disabled: _vm.optionType !== "add",
                            label: 2,
                          },
                        },
                        [_vm._v("实时生成")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.generateType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "数量", prop: "generateNum" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.optionType !== "add",
                          clearable: "",
                          maxlength: "99",
                          size: "small",
                          placeholder: "请输入激活码数量",
                        },
                        model: {
                          value: _vm.form.generateNum,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "generateNum", $$v)
                          },
                          expression: "form.generateNum",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "激活码商品", prop: "cdkeyGoodsId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.optionType !== "add",
                        placeholder: "请选择激活码商品",
                        clearable: "",
                        size: "small",
                      },
                      on: { change: _vm.getGoodsDetail },
                      model: {
                        value: _vm.form.cdkeyGoodsId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cdkeyGoodsId", $$v)
                        },
                        expression: "form.cdkeyGoodsId",
                      },
                    },
                    _vm._l(_vm.activeGoodList.value, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.form.cdkeyGoodsId
                ? _c("el-form-item", { attrs: { label: "商品详情" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.goodsDetail))]),
                  ])
                : _vm._e(),
              _vm.form.generateType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "激活码过期时间", prop: "expireTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled: _vm.optionType !== "add",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetime",
                          clearable: "",
                          size: "small",
                          placeholder: "选择时间",
                        },
                        model: {
                          value: _vm.form.expireTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expireTime", $$v)
                          },
                          expression: "form.expireTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.generateType === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "激活码有效期", prop: "validDays" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.optionType !== "add",
                          clearable: "",
                          maxlength: "99",
                          size: "small",
                          placeholder: "请输入激活码有效期",
                        },
                        model: {
                          value: _vm.form.validDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "validDays", $$v)
                          },
                          expression: "form.validDays",
                        },
                      }),
                      _c("span", [_vm._v(" 天")]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "业务类型", prop: "businessType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.optionType !== "add",
                        placeholder: "请选择业务类型",
                        clearable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.form.businessType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "businessType", $$v)
                        },
                        expression: "form.businessType",
                      },
                    },
                    _vm._l(_vm.businessTypeList.value, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图片附件", prop: "img" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            "before-upload": _vm.checkUpload,
                            "http-request": _vm.upload,
                            listType: "picture-img",
                            "show-file-list": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传文件")]
                          ),
                        ],
                        1
                      ),
                      _vm.form.img
                        ? _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  "margin-right": "10px",
                                },
                                attrs: {
                                  "preview-src-list": [_vm.form.img],
                                  src: _vm.form.img,
                                  fit: "scale-down",
                                },
                              }),
                              _c("el-button", {
                                staticStyle: { color: "#ad1e1c" },
                                attrs: { type: "text", icon: "el-icon-remove" },
                                on: { click: _vm.delPic },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: " 备注", prop: "descr" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      "show-limit-word": "",
                      clearable: "",
                      maxlength: "9999",
                      size: "small",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.form.descr,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "descr", $$v)
                      },
                      expression: "form.descr",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }